import * as React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import Header from "src/components/Marginals/Header";
import { IHeaderContainer } from "src/ScrollyInterface";
import * as actions from "src/store/actions/index";
import { IStateApp, IToggleSideDrawerAction } from "src/store/StoreInterface";

const headerContainer = (props: IHeaderContainer) => {
  const {
    breakpoint,
    content,
    links,
    navImages,
    navType,
    onToggleSideDrawer,
    showSideDrawer
  } = props;
  return (
    <Header
      breakpoint={breakpoint}
      contentId={content.id}
      header={content.header}
      links={links}
      navImages={navImages}
      navType={navType}
      onToggleSideDrawer={onToggleSideDrawer}
      showSideDrawer={showSideDrawer}
    />
  );
};

const mapStateToProps = (state: IStateApp) => {
  return {
    breakpoint: state.ui.breakpoint,
    content: state.data.content,
    showSideDrawer: state.ui.showSideDrawer
  };
};

const mapDispatchToProps = (dispatch: Dispatch<IToggleSideDrawerAction>) => {
  return {
    onToggleSideDrawer: (val: boolean) =>
      dispatch(actions.toggleSideDrawer(val))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(headerContainer);



// WEBPACK FOOTER //
// ./src/containers/HeaderContainer.tsx